import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';
const buttonVariants = cva('cursor-pointer inline-flex items-center justify-center whitespace-nowrap rounded-md text-[16px] font-sourcecodepro font-light leading-[20.11px] text-center transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:fill-current w-fit disabled:cursor-not-allowed', {
  variants: {
    variant: {
      default: 'bg-primary text-foreground shadow hover:bg-primary hover:brightness-110 active:bg-primary active:brightness-90 disabled:bg-slate-200 disabled:text-slate-400 disabled:border-slate-200',
      ghost: 'bg-transparent text-foreground/30 hover:text-foreground active:text-foreground/50 disabled:text-foreground/20'
    },
    size: {
      default: 'h-[52px] gap-[8px] px-[16px] rounded-[4px] text-[16px] [&_svg]:size-6',
      medium: 'h-[44px] gap-[8px] px-[16px] rounded-[4px] text-[15px] [&_svg]:size-5',
      small: 'h-[33px] gap-[4px] px-[12px] rounded-[4px] text-[15px] [&_svg]:size-4',
      icon: 'h-9 w-9'
    }
  },
  defaultVariants: {
    size: 'default'
  }
});
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  size = 'default',
  asChild = false,
  variant = 'default',
  disabled,
  ...props
}, ref) => {
  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(buttonVariants({
    size,
    variant,
    className
  }), asChild && disabled && 'pointer-events-none bg-slate-200 text-slate-400 border-slate-200')} ref={ref} disabled={disabled} {...props} />;
});
Button.displayName = 'Button';
export { Button, buttonVariants };